import request from '@/utils/request'

// 查询会费列表
export function selectSysDeptFeeByDeptId(data) {
    return request({
        url: '/h5/userDept/selectSysDeptFeeByDeptId',
        method: 'post',
        data: data
    })
}

// 查询用户协会关系列表
export function listUserDept(query) {
    return request({
        url: '/h5/userDept/list',
        method: 'get',
        params: query
    })
}

// 查询用户协会关系详细
export function getUserDept(id) {
    return request({
        url: '/h5/userDept/' + id,
        method: 'get'
    })
}


// 查询用户协会关系
export function getUserDeptByUserIdAndDeptId(deptId) {
    return request({
        url: '/h5/userDept/getByDeptId/' + deptId,
        method: 'get'
    })
}

// 查询用户协会列表
export function selectUserDeptByUserId() {
    return request({
        url: '/h5/userDept/selectUserDeptByUserId',
        method: 'get'
    })
}

// 新增用户协会关系
export function addUserDept(data) {
    return request({
        url: '/h5/userDept',
        method: 'post',
        data: data
    })
}

// 修改用户协会关系
export function updateUserDept(data) {
    return request({
        url: '/h5/userDept',
        method: 'put',
        data: data
    })
}

// 删除用户协会关系
export function delUserDept(id) {
    return request({
        url: '/h5/userDept/' + id,
        method: 'delete'
    })
}
